import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther } from "viem";
import chinaAbi from "../../utils/chinaAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";
import { contractIsSpecialCodeArg } from "../../utils/specialUser";

const usePurchaseLink = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAdress = Environment.link;

  const purchaseLink = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex, index, insurancePer) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      let nd;
      if (index) {
        const value = parseFloat(amount) + parseFloat(amount) * insurancePer;
        const valueAmount = Math.round(parseFloat(value.toFixed(6)) * 1e12) / 1e12;
        nd = parseEther(valueAmount.toString());
      } else {
        const valueAmount = Math.round(parseFloat(parseFloat(amount).toFixed(6)) * 1e12) / 1e12;
        nd = parseEther(valueAmount.toString());
      }

      let minValue = Math.round(parseFloat((min * 0.99).toFixed(6)) * 1e12) / 1e12;
      minValue = parseEther(minValue.toString());

      console.log("purchaseLink params:", nd, minValue, postApiRes.code, id);

      try {
        const hash = await writeContractAsync({
          address: Environment.presaleContract,
          abi: chinaAbi,
          functionName: "purchaseTokenWithToken",
          args: [
            UsdtAdress,
            postApiRes?.normalizationFactor,
            postApiRes?.normalizationFactorNft,
            postApiRes?.price,
            nd,
            minValue,
            postApiRes?.agentsAddresses,
            postApiRes?.agentsPercentages,
            postApiRes.code,
            id,
            postApiRes.deadline,
            contractIsSpecialCodeArg(postApiRes),
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("purchaseLink tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("purchaseLink confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("purchaseLink error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseLink };
};

export default usePurchaseLink;
